'use client';
import { jsx } from 'react/jsx-runtime';
import { deprecatedComponent } from '../core/deprecated-component.js';
import { renderWithRef } from '../core/render-with-ref.js';
import { RenderComp } from '../core/render-comp.component.js';

function _object_without_properties(e, r) {
    if (null == e) return {};
    var o, t, n = _object_without_properties_loose(e, r);
    if (Object.getOwnPropertySymbols) {
        var i = Object.getOwnPropertySymbols(e);
        for(t = 0; t < i.length; t++)o = i[t], !(r.indexOf(o) >= 0) && Object.prototype.propertyIsEnumerable.call(e, o) && (n[o] = e[o]);
    }
    return n;
}
function _object_without_properties_loose(e, r) {
    if (null == e) return {};
    var o, t, n = {}, i = Object.keys(e);
    for(t = 0; t < i.length; t++)o = i[t], r.indexOf(o) >= 0 || (n[o] = e[o]);
    return n;
}
let n = renderWithRef('ThumbnailsHeroBackgroundContainer', null, (r, t)=>{
    var { children: n } = r;
    return jsx(RenderComp, {
        root: "div",
        forwardedRef: t,
        classNames: [
            'swan-thumbnails-hero-background-container'
        ],
        props: _object_without_properties(r, [
            "children"
        ]),
        children: n
    });
});
const ThumbnailsHeroBackgroundContainer = deprecatedComponent({
    description: 'Use AdaptiveCarousel instead',
    displayName: 'ThumbnailsHeroBackgroundContainer',
    root: n
});

export { ThumbnailsHeroBackgroundContainer };
